module.exports = __webpack_public_path__ + "src/assets/img/plotkin.33e253ed.png";